export function ToSnakeCaseString(defaultString: string): string {
  return defaultString.replace(/[A-Z]/g, (letter, index) => {
    return index == 0 ? letter.toLowerCase() : "_" + letter.toLowerCase();
  });
}
